<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations?.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations?.lbl_loading}}</span>
</div>


<!-- MAIN SCREEN -->
<div class="card" *ngIf="translations && globalUserPreferences?.storeId != null">

    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">

        <!-- LANGUAGE FORM -->
        <div class="p-col-12 p-md-6">
            <p-panel>

                <div class="p-fluid" [formGroup]="globalUserDataForm">

                    <!-- COORDINATION INPUT FORM -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1"
                        *ngIf="translations != null && globalUserDataForm.get('selectedCoordination').value != null">
                        <span>{{ translations.lbl_coordination }}</span>
                        <ng-container
                            *ngIf="globalUserDataForm.get('selectedCoordination').value != null; else noSelectionCoordination">
                            <span class="p-text-bold">
                                {{ globalUserDataForm.get('selectedCoordination').value || " " }}</span>
                        </ng-container>

                        <ng-template #noSelectionCoordination>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_coordination
                                + ' ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div>

                    <!-- GUIDE INPUT FORM -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1"
                        *ngIf="translations != null && globalUserDataForm.get('selectedGuide').value != null">
                        <span>{{ translations.lbl_guide }}</span>
                        <ng-container
                            *ngIf="globalUserDataForm.get('selectedGuide').value != null; else noSelectionGuide">
                            <span class="p-text-bold">
                                {{ globalUserDataForm.get('selectedGuide').value || " " }}</span>
                        </ng-container>

                        <ng-template #noSelectionGuide>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_guide
                                + ' ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div>

                    <!-- INPUT LANGUAGE
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1"
                        *ngIf="translations != null && globalUserDataForm.get('selectedLanguage').value != null">
                        <span>{{ translations.lbl_language }}</span>
                        <ng-container
                            *ngIf="globalUserDataForm.get('selectedLanguage').value != null; else noSelectionLanguage">
                            <span class="p-text-bold">
                                {{ globalUserDataForm.get('selectedLanguage').value?.value || " " }}</span>
                        </ng-container>

                        <ng-template #noSelectionLanguage>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_language
                                + ' ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div> -->

                    <!-- INPUT PERIOD -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1"
                        *ngIf="translations != null && globalUserDataForm.get('selectedPeriod').value != null">
                        <span>{{ translations.lbl_period }}</span>
                        <ng-container
                            *ngIf="globalUserDataForm.get('selectedPeriod').value != null; else noSelectionPeriod">
                            <span class="p-text-bold">
                                {{ globalUserDataForm.get('selectedPeriod').value?.descrip || " " }}</span>
                        </ng-container>

                        <ng-template #noSelectionPeriod>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_period
                                + ' ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div>
                </div>
            </p-panel>
        </div>
    </div>

    <br />

    <!-- TAB VIEW -->
    <p-tabView>
        <!-- TAB PANEL -->
        <p-tabPanel [header]="translations.lbl_orders_request">

            <p-table #dt1 [value]="materialReqLst" [showCurrentPageReport]="false"
                [globalFilterFields]="colsGlSales" responsive="true" editMode="row" dataKey="id" selected="true">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reloadGetMaterialRequestLst()" pTooltip="{{translations.lbl_reload}}"
                                tooltipPosition="bottom"></button>

                            <button pButton pRipple
                                pTooltip="{{translations.lbl_new}} {{translations.lbl_delivery}} {{translations.lbl_material}}"
                                tooltipPosition="bottom" class="p-m-2 z-5" icon="pi pi-plus"
                                (click)="redirectToSupplyDtl('S',null,null,null,false,0,null,0,null)"></button>
                            <!-- label="{{translations.lbl_new}} {{translations.lbl_delivery}} {{translations.lbl_material}}" -->

                            <button pButton pRipple
                                pTooltip="{{translations.lbl_new_return}} {{translations.lbl_material}}"
                                tooltipPosition="bottom" icon="pi pi-minus" class="p-button-danger p-m-2 z-5"
                                (click)="redirectToSupplyDtl('R',null,null,null, false,0,null,0,null)"></button>
                            <!-- label="{{translations.lbl_new_return}} {{translations.lbl_material}}" -->
                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{translations.lbl_year}}</th>
                        <th>{{translations.lbl_sequence}}</th>
                        <th colspan="2">{{translations.lbl_service}}</th>
                        <th>{{translations.lbl_status}}</th>
                        <th>{{translations.lbl_request_date}}</th>
                        <th colspan="2">{{translations.lbl_type}}</th>
                        <!-- <th class="text-right">{{translations.lbl_quantity}}</th> -->
                        <th class="text-right">{{translations.lbl_amount}}</th>
                        <th>{{translations.lbl_actions}}</th>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-valor let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="valor">
                        <td>{{ valor.year }}</td>
                        <td>{{ valor.sequence }}</td>
                        <td colspan="2">{{ valor.dataService ? valor.dataService: translations.lbl_no + ' ' +
                            translations.lbl_associated + ' ' + translations.lbl_to + ' ' + translations.lbl_service}}
                        </td>


                        <td>{{ valor.status == 'R' || valor.status == 'C' ? translations.lbl_closed_request :
                            valor.status == 'N' ? translations.lbl_opened_request : ''}}</td>

                        <td>{{ valor.currDate != ' ' ?
                            tovpilUtils.dateToTovpilDateFormat(tovpilUtils.stringToDate(valor.currDate)) : '' }}</td>

                        <!-- TIPO -->
                        <td colspan="2">{{ valor.docType ? valor.docType == 'S' ?
                            entryTypes[0] : valor.docType == 'R' ? entryTypes[1] : '': ""}}</td>

                        <!-- UNIDADES -->
                        <!-- <td class="text-right" *ngIf="!valor.mostrarComponente">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <p-inputNumber inputId="withoutgrouping" [(ngModel)]="valor.unitNum"
                                        [minFractionDigits]="0" [maxFractionDigits]="0" mode="decimal" [min]="0"
                                        [useGrouping]="false"></p-inputNumber>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <span>
                                        {{ valor?.unitNum || 0 }} {{translations.lbl_unit_suffix}}
                                    </span>
                                </ng-template>
                            </p-cellEditor>
                        </td> -->
                        <td class="text-right">{{ valor?.totAmt != null ? valor?.totAmt.toFixed(2) : 0 }} </td>

                        <td style="text-align:center"
                            *ngIf="valor.sequence != null && valor.year != null && valor.canEdit">

                            <button *ngIf="valor.status == 'N'" pButton pRipple icon="pi pi-pencil"
                                class="p-button-rounded p-button-warning p-mr-2"
                                (click)="redirectToLocMatLstD(valor)"></button>

                            <button *ngIf="valor.status == 'R' || valor.status == 'C'" pButton pRipple
                                icon="pi pi-search" class="p-button-rounded p-mr-2"
                                (click)="redirectToLocMatLstD(valor)"></button>

                            <!-- SE RETIRA PARA EVITAR INCONSISTENCIAS-->
                            <!-- <button [disabled]=" valor.status == 'R'" *ngIf="!editing" pButton pRipple type="button"
                                pInitEditableRow class="p-button-warning p-button-rounded p-mr-2" icon="pi pi-pencil"
                                pTooltip="{{translations.lbl_edit}}" (click)="onRowEditInit(valor)"></button> -->

                            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                                (click)="onRowEditSave(valor)"
                                class="p-button-rounded p-button-text p-button-success p-mr-2"></button>

                            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                                (click)="onRowEditCancel(valor)"
                                class="p-button-rounded p-button-text p-button-danger"></button>

                            <button [disabled]="valor.status == 'R' || valor.status == 'C'" pButton icon="pi pi-trash"
                                class="p-button-danger p-button-rounded p-mr-2" (click)="onRowDelete(valor)"
                                pTooltip="{{translations.lbl_delete_record}}"
                                *ngIf="valor.sequence != null && valor.year != null"></button>
                        </td>
                    </tr>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>

                        <td [attr.colspan]="columns ? columns.length : 9">
                            {{translations.lbl_no_records_found}}
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_there_are}} {{materialReqLst != null ? materialReqLst.length > 0 ? materialReqLst.length -1 : 0 : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>

        </p-tabPanel>
    </p-tabView>
</div>


<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="globalUserPreferences?.storeId == null" class=" overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta mas tarde ... </span>
</div>